/**
 * Eyebrow — mono uppercase micro-label used above page and section titles.
 *
 * WeaveIn twin of Triveny's TvEyebrow (JetBrains Mono 10px / 500 / 0.14em).
 * Convention: "Area · Subsection" (e.g. "Billing · Claims", "Admin · Compliance").
 */
import React from 'react'

interface EyebrowProps {
  children: React.ReactNode
  className?: string
}

export function Eyebrow({ children, className = '' }: EyebrowProps) {
  return (
    <div
      className={`font-mono text-[10px] font-medium uppercase tracking-[0.14em] text-ink-500 ${className}`}
    >
      {children}
    </div>
  )
}
